import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { sessionEnd } from "../../redux/actions/index";

// MaterialUI
import { Card, Alert, Typography, Box, Container, CssBaseline } from "@mui/material";
import NavTab from "../../layout/NavTab";

// React router
import { useNavigate } from "react-router-dom";

// Fetch
import { fetchPostProtect } from "../../fetchs/post";

// Components
import AddUpdateProject from "../../components/Projects/AddUpdateProject";

interface IFormValues {
  name: string;
  description: string;
  client: string;
}

const AddProject = () => {
  const [error, setError] = useState<string>("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector((state: RootState) => state.user.token);
  const author = useSelector((state: RootState) => state.user.username);

const addProject = async (values: IFormValues, matriceID: string = "", customRef: string = "") => {
  const body = JSON.stringify({
    name: values.name,
    description: values.description,
    client: values.client,
    author: author,
    defaultMatrice: matriceID,
    customRef: customRef,
  });

    if (token) {
      fetchPostProtect(token, "/projects/add", body)
        .then((response) => {
          if (response.status === 200) {
            setError("");
            response.json().then((result) => {
              navigate(`/projet/${result._id}`, { state: "projectSuccess" });
            });
          } else if (response.status === 401) {
            dispatch(sessionEnd());
          } else {
            response.json().then((result) => setError(result.message));
          }
        })
        .catch((err) => setError(err));
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc" }}>
      <CssBaseline />
      
      {/* HEADER AVEC BOUTON RETOUR INTÉGRÉ */}
      <NavTab 
        text="Ajouter un projet" 
        displayReturn={true} 
        project={true} // Pour que NavTab sache qu'il doit revenir à /projets/
      />

      <Container maxWidth="sm" sx={{ mt: 4, pb: 8 }}>
        <Card
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: "24px",
            border: "1px solid #e2e8f0",
            bgcolor: "white",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05)"
          }}
        >
          <Box sx={{ mb: 4, textAlign: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: 800, color: "#1e293b", mb: 1 }}>
              Nouveau Projet
            </Typography>
            <Typography variant="body2" sx={{ color: "#64748b" }}>
              Remplissez les informations ci-dessous pour initialiser votre nouveau chiffrage.
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3, borderRadius: "12px" }}>
              {error}
            </Alert>
          )}

          <Box sx={{ width: "100%" }}>
            <AddUpdateProject handleSubmit={addProject} edit={false} />
          </Box>
        </Card>
      </Container>
    </Box>
  );
};

export default AddProject;